import { HIDE_DIALOG, SHOW_DIALOG } from '../actions/DialogAction'
const initialState ={
    header: null,
    body: null,
    icon: null,
    labelOk:null,
    labelCancel: null,
    severity:"",  
    show:false ,   
    okHandler:null,
    cancelHandler:null 
}

const DialogReducer = (state = initialState, action) => {   
    switch(action.type){
        case SHOW_DIALOG:           
            return {...state, header: action.header, body: action.body, icon:action.icon, labelOk:action.labelOk, labelCancel:action.labelCancel, severity:action.severity, okHandler:action.okFn, cancelHandler:action.cancelFn, show:true}        
        case HIDE_DIALOG:
            return {...state,  header: null, body: null, icon:null, labelOk:null, labelCancel:null, severity:null, okHandler:null, cancelHandler:null, show:false,}
        default:
            return {...state}
    }
}

export default DialogReducer;
